import styles from './Classification.module.scss'
import Heading from '../Heading/Heading'
import Image from 'next/image'
import { ClassificationProps } from '~types'
import { NEXT_IMAGE_QUALITY } from '~constants'
import Paragraph from '../Paragraph/Paragraph'

const Classification = ({ title, description, ratingImage, ratingNumber = 4 }: ClassificationProps) => {
  return (
    <div className={styles['classification-container']}>
      <div>
        {Number.isInteger(ratingNumber) &&
          ratingNumber > 0 &&
          ratingImage?.url &&
          Array.from({ length: ratingNumber }).map((_, index) => (
            <Image
              key={`star_rating_${index}`}
              width={34}
              height={32}
              alt={ratingImage?.altText || ''}
              sizes='100vw'
              src={ratingImage.url}
              quality={NEXT_IMAGE_QUALITY}
            />
          ))}
      </div>
      {(title || description) && (
        <blockquote>
          {title && (
            <Heading level={4} levelDisplay='eyebrow' color='accent' justify='center'>
              {title}
            </Heading>
          )}
          {description && <Paragraph text={{ html: `<p>${description}</p>` }} fontSize='lg' justify='center' />}
        </blockquote>
      )}
    </div>
  )
}

export default Classification
